export default "__VITE_ASSET__BdzUZJLB__"